import getById from 'utils/DOM/getById'
import toggleClass from 'utils/DOM/toggleClass'
import { COMPARE_PLANS } from 'sites/routes'

function renderRecommendedLink(recommendDurations) {
  const recommendedPlanIds = Object.keys(recommendDurations)

  const compareRecommendedLink = recommendedPlanIds.reduce((accum, key) => {
    const duration = recommendDurations[key]
    // cspell:disable-next-line
    return `${accum ? `${accum},` : ''}${key}-${duration.duration}-${duration.policies}`
  }, '')

  const compareRecommended = getById('tiles-compare')
  compareRecommended.setAttribute(
    'href',
    `${COMPARE_PLANS}?plans=${compareRecommendedLink}`
  )
  toggleClass(compareRecommended, 'd-md-flex', recommendedPlanIds.length > 1)
}

export default renderRecommendedLink
